import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { Role } from "@/types/organization-roles";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface GetOrganizationRolesResponse {
  roles: Role[];
}

export const useGetOrganizationRoles = (organizationId: number, enabled = true) => {
  const userToken = useUserToken();
  return useQuery({
    queryKey: ["organization-roles", organizationId],
    queryFn: async (): Promise<GetOrganizationRolesResponse> =>
      fetch(ENDPOINTS.get_organization_roles(organizationId), {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    enabled: enabled && !!organizationId,
  });
};
